// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Environment_codec from "../../shared/wire/environment_codec.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";

function revision(row) {
  const value = Mapre_wire__Environment_codec.decode(Mapre_wire__Json.get(row, "configuration"));
  let configuration;
  if (value.TAG === /* Ok */ 0) {
    configuration = value._0;
  } else {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: value._0
      });
  }
  return {
    version: Mapre_wire__Json.integer(row, "version"),
    configuration,
    actor: Js__Js_json.decodeString(Mapre_wire__Json.get(row, "created_by"))
  };
}

function receipt(json) {
  return {
    revision: revision(Mapre_wire__Json.get(json, "environment")),
    project_version: Mapre_wire__Json.integer(json, "project_version"),
    current_version: Mapre_wire__Json.integer(json, "current_version")
  };
}

function history(json) {
  const next = Mapre_wire__Json.get(json, "next_version");
  return [
    Stdlib__List.map(revision, Stdlib__Array.to_list(Mapre_wire__Json.array(json, "versions"))),
    Caml_obj.caml_equal(next, null) ? undefined : Mapre_wire__Json.integer(json, "next_version")
  ];
}

function body(form, configuration) {
  return JSON.stringify(Js__Js_dict.fromList({
    hd: [
      "request_id",
      Mapre_wire__Json.str(form.request_id)
    ],
    tl: {
      hd: [
        "expected_version",
        form.project_version
      ],
      tl: {
        hd: [
          "configuration",
          Mapre_wire__Environment_codec.encode(configuration)
        ],
        tl: /* [] */ 0
      }
    }
  }));
}

export {
  receipt,
  history,
  body,
}
/* Mapre_wire__Environment_codec Not a pure module */
